import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getAuthToken, removeAuthToken } from '../Helper/authToken';

const fetchBaseApi = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_APIBaseUrl,
  prepareHeaders: (headers) => {
    const token = getAuthToken();
    if (token) headers.set('Authorization', `Bearer ${token}`);
    headers.set('Content-Type', 'application/json');
    return headers;
  },
});

export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: async (args, api, extraOptions) => {
    try {
      const result = await fetchBaseApi(args, api, extraOptions);
      return result;
    } catch (error: any) {
      if (error.status === 401) {
        removeAuthToken();
        window.location.replace('/auth/login');
      }
      throw error;
    }
  },
  tagTypes: [
    'PackageWhatsAppGrp',
    'spInvoice',
    'CommunitiesPanel',
    'Users',
    'Roles',
    'BulkStudentActivation',
    'Franchise',
    'FranchiseCloud',
    'Modules',
    'RoutePermission',
    'ModulePermission',
    'Routes',
    'AppUpdate',
    'BlackWhiteList',
    'ClientApi',
    'CommunityForum',
    'CourseBuilder',
    'dashboard',
    'Device',
    'EmailTemplates',
    'FranchiseExternalLogin',
    'FranchiseOtherDetails',
    'Key',
    'InternalServices',
    'LivePoll',
    'Report',
    'PaymentMode',
    'Storage',
    'StudentActivationKeys',
    'StudentActivationKeysEmailSend',
    'StudentManagement',
    'StudentAttendance',
    'StudentManagement',
    'ActivationKeyPermission',
    'ActivationKey',
    'AppBanner',
    'AppStore',
    'spTblAppStore2',
    'TblBackupVideo',
    'Books',
    'BulkStudentImport',
    'TblCoupon',
    'Courier',
    'Courses',
    'CourseDetail',
    'CoursesTemplate',
    'DocumentDetails',
    'EncryptionUnassignedApi',
    'EncryptionHistory',
    'FacultiesMaster',
    'Faq',
    'FormMaster',
    'FranchisePlayer',
    'IP',
    'MCQSet',
    'mcqQuestion2',
    'MCQResult',
    'MCQTestApi',
    'Origin',
    'sectionChapters',
    'UserAgent',
    'McqSeries',
    'Notification',
    'NotificationList',
    'Package',
    'PackageCombo',
    'PackageDetail',
    'PackageDuplicate',
    'PackageFaculty',
    'PackagePdf',
    'PlayerDownload',
    'Podcast',
    'QuestionAnswer',
    'Settings',
    'SocialMedia',
    'Term',
    'checkerPermission',
    'TheoryExamAnswer',
    'TheoryExamSetTags',
    'UserProfile',
    'Vendor',
    'BackupDetail',
    'VideoDetails',
    'spUserChangeRecord',
    'Template',
    'Users',
    'WebsiteVideo',
    'ResellerCommission',
    'ResellerCoupon',
    'ResellerTransaction',
    'Reseller',
    'Webinar',
    'ExamCertificate',
    'ApiAccessTokens',
    'CopyPackageContent',
    'SPTblBulkValidity',
    'SpMindMap',
    'PackageExtension',
    'SpMigration',
    'SpRegistrationValidate',
    // client
    'SPBlogCategories',
    'spBlogPost',
    'spBlogTags',
    'sp_BlogTemplate',
    'spInternalService2',
    'ClientRouteApi',
    'SPFreeResource',
    'MasterFranchise',
    'SalesDashboard',
    'ContentManagement',
    'Contents',
    'LayoutStore',
    'LibraryLinks',
    'LivePageMetaTags',
    'AllocationLibraryLink',
    'AllocationTemplate',
    'Pages',
    'Sections',
    'WebApiPaymentCommon',
    'PackageStudyMaterial',
    'TblHardcopy',
    'TblHardcopyStocks',
    'SPPackageQuantityDiscount',
    'PackageCertificateTemplate',
    'SPTblPackageTestimonial',
    'SPConsentForm',
    'SPAadharListVerify',
    'ScheduleCallSettings',
    'CoursePackageLink',
    'StudentGSTBilling',
    // support db
    'spSupportTicket',
    // invoice bd
    'DTHLMSInvoice',
    'PaymentApi',
    'SPResellerPackageApi',
    'SPResellerPackagePriceApi',
    'GenericAPICall',
    'SPResellerStudentActivationApi',
    'SPResellerDashboardApi',
  ],
  endpoints: () => ({}), // no endpoints here
});

export default baseApi;
